var _excluded = ["text", "price", "link"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import { cover } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import TextAtm from "../../atoms/TextAtm";
import { cssTextAtm } from "../../atoms/TextAtm/TextAtm.styled";
import Link from "../../quarks/Link";
var textGutterSpace = 1;
var Wrapper = styled.div.withConfig({
  componentId: "sc-1s96ik8-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["position:relative;flex-wrap:nowrap;align-items:center;", "{display:flex;}", "{display:inline-flex;padding:", ";border:", " solid ", ";border-radius:", ";}"], breakpoint("large"), breakpoint("small", "large"), space(1), unit(1), getBorderColor(theme, $onColor, "low"), getBorderRadius(theme, "large"));
});
var Text = styled(Link).withConfig({
  componentId: "sc-1s96ik8-1"
})(function (_ref2) {
  var $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["", ";text-decoration:none;&::before{", ";content:\"\";}", "{margin-right:", ";padding-right:", ";border-right:", " solid ", ";}", "{margin-right:", ";}"], cssTextAtm({
    typography: "big2",
    onColor: $onColor
  }), cover(), breakpoint("large"), space(textGutterSpace), space(textGutterSpace), unit(1), getBorderColor(theme, $onColor, "medium"), breakpoint("small", "large"), space(1));
});
function ItemPriceLinkMol(_ref3) {
  var text = _ref3.text,
    price = _ref3.price,
    link = _ref3.link,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $onColor: onColor
  }, restProps), /*#__PURE__*/React.createElement(Text, _extends({}, link, {
    $onColor: onColor
  }), text), /*#__PURE__*/React.createElement(TextAtm, {
    typography: "small2",
    emphasis: "medium"
  }, price));
}
export default ItemPriceLinkMol;